export const formFieldsOptions = ( formData ) => {
  if ( formData.addonType == 'addon' || formData.addonType == 'inner_addon' ) {
      var addonOps = addonsJSON[formData.addonName];
      Object.assign( addonOps.attr, globalAttr );

      return addonOps;
  } else if ( formData.addonType == 'column' || formData.addonType == 'inner_column' ) {
      return colSettings; // available in global scope
  } else if ( formData.addonType == 'row' || formData.addonType == 'inner_row' ) {
      return rowSettings; // available in global scope
  }
}


var addonRow = {
    id: 123456789,
    settings: {},
    layout : '12',
    columns: [{
        id: 7000000,
        class_name: 'col-md-12',
        settings: {},
        addons:[]
    }]
}



// WEBPACK FOOTER //
// ./src/helpers/form/common.js